export const getLangJson = ({ state }) => state.LangReducer.langJson;

export const getLang = ({ state }) => state.LangReducer.lang;